import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import noLocale from 'date-fns/locale/nb';
import { i18n } from 'i18next';

import { formatDate } from '../../helpers/formatters';

export const getRemainingTime = (time: string, i18: i18n) => {
    const formattedDate = formatDate(time, i18.language);
    const distance = formatDistanceToNow(
        new Date(time),
        { locale: i18.language.toLowerCase() === 'no'
            ? noLocale
            : undefined,
        }
    );
    return `${formattedDate} (${distance})`;
};
